import { Observable } from 'rxjs';

import { GuardJobDetails } from '../../../../../types';
import { UnitResult } from '../../../../error';

export abstract class GetGuardJobDetails {
    abstract execute(id: number): Observable<UnitResult<GuardJobDetails>>;
}
